/* unplugin-vue-components disabled */import { render } from "./IconButton.vue?vue&type=template&id=64d58f89&scoped=true&ts=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"

import "./IconButton.vue?vue&type=style&index=0&id=64d58f89&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d58f89"]])

export default __exports__